import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@store/baseQueries";
import {
  fetchHTML,
  fetchSidebarProducts,
  fetchSidebarProductsSubsectionList,
  fetchTableData,
} from "./queries";
import { productsBaseUrl } from "@store/urlPaths";

const productsApi = createApi({
  reducerPath: "products",
  baseQuery: baseQuery(productsBaseUrl),
  endpoints: (builder) => ({
    // fetch sidebar products
    fetchSidebarProducts: builder.query({
      query: fetchSidebarProducts,
    }),

    // fetch sidebar products subsection list
    fetchSidebarProductsSubsectionList: builder.query({
      query: fetchSidebarProductsSubsectionList,
    }),

    // table data
    fetchTableData: builder.query({
      query: fetchTableData,
    }),

    // table html
    fetchHTML: builder.query({
      query: fetchHTML,
    }),
  }),
});

export const {
  useFetchSidebarProductsQuery,
  useFetchSidebarProductsSubsectionListQuery,
  useFetchTableDataQuery,
  useLazyFetchHTMLQuery,
  reducer: productsReducer,
  reducerPath: productsReducerPath,
  middleware: productsMiddleware,
} = productsApi;
